import { Controller } from '@hotwired/stimulus'
import Highcharts from 'highcharts'
import HcExporting from 'highcharts/modules/exporting'
import HcExportData from 'highcharts/modules/export-data'

HcExporting(Highcharts)
HcExportData(Highcharts)

export class TurnoverController extends Controller {
  static targets = [ 'chart', 'form', 'loader' ]
  static values  = { url: String, stacking: Boolean }
  static classes = [ 'hidden' ]

  initialize() {
    this.alreadyFetched = {}
  }

  connect() {
    this.changePeriod()
    this.changeAffiliate()
  }

  initChart() {
    let options

    if (this.stackingValue) {
      options = {
        chart: { type: 'line' }
      }
    } else {
      options = {
        chart: { type: 'column' },
        plotOptions: { column: { stacking: 'normal' } }
      }
    }

    if (this.formTarget.querySelector("[data-quantity]")?.checked) {
      options['yAxis'] = { title: { text: "Volume" } }
      options['tooltip'] = { formatter: function() { return `<strong>${this.series.name}</strong><br/>${this.x}: ${this.y} ${ (this.percentage) ? ('(' + this.percentage.toFixed(2) + '%)') : ''}` } }
    } else {
      options['yAxis'] = { title: { text: "Chiffre d'affaire en euros" } }
      options['tooltip'] = { formatter: function() { return `<strong>${this.series.name}</strong><br/>${this.x}: ${Highcharts.numberFormat(this.y)} € ${ (this.percentage) ? ('(' + this.percentage.toFixed(2) + '%)') : ''}` } }
    }

    this.chart = Highcharts.chart(this.chartTarget, {
      ...options,
      exporting: { buttons: { contextButton: { menuItems: ['downloadXLS', 'downloadCSV'] } } },
      navigation: { menuItemHoverStyle: { background: '#db2777', color: '#ffffff' } }
    })

  }

  load() {
    if (!this.stackingValue)
      this.reset()
    this.getData()
  }

  reload() {
    this.reset()
    this.getData()
  }

  reset() {
    if (this.chart) this.chart.destroy()
    this.alreadyFetched = {}
    this.initChart()
  }

  changePeriod() {
    let period = this.formTarget.querySelector("[data-period-select]").value
    this.formTarget.querySelectorAll("[data-period]").forEach(element => element.classList.add(this.hiddenClass))
    this.formTarget.querySelectorAll(`[data-period*="${period}"]`).forEach(element => element.classList.remove(this.hiddenClass))
    this.reset()
    this.getData()
  }

  changeAffiliate() {
    let hide = document.getElementById('turnover_affiliate_type').value != 'LeadCampaign'
    this.formTarget.querySelector("[data-lead-campaign]").classList.toggle(this.hiddenClass, hide)
  }

  getData() {
    this.loaderTarget.classList.remove(this.hiddenClass)
    let url = new URL(this.urlValue)
    url.search = new URLSearchParams(new FormData(this.formTarget)).toString()
    fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(response => response.json())
      .then(data => {
        this.chart.xAxis[0].setCategories(data.ticks)

        data.series.forEach(series => {
          if (!this.alreadyFetched[series.name]) {
            this.alreadyFetched[series.name] = true
            this.chart.addSeries(series)
          }
        })

        this.loaderTarget.classList.add(this.hiddenClass)
      })
  }
}
export default TurnoverController